"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var getDefaultTemplate = function getDefaultTemplate(metadata) {
  if (metadata === void 0) {
    metadata = {};
  }

  var _metadata = metadata,
      _metadata$address = _metadata.address1,
      address1 = _metadata$address === void 0 ? "Address1" : _metadata$address,
      _metadata$address2 = _metadata.address2,
      address2 = _metadata$address2 === void 0 ? "Address2, Country" : _metadata$address2;
  return {
    "blocks": [{
      "key": "9hkrk",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }, {
      "key": "f4lh3",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }, {
      "key": "7kca5",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }, {
      "key": "dr7ve",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }, {
      "key": "4rq3t",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }, {
      "key": "1avh3",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }, {
      "key": "a8sis",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }, {
      "key": "ddv6t",
      "text": " ",
      "type": "atomic",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [{
        "offset": 0,
        "length": 1,
        "key": 0
      }],
      "data": {}
    }, {
      "key": "f5anh",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {}
    }],
    "entityMap": {
      "0": {
        "type": "footer",
        "mutability": "IMMUTABLE",
        "data": {
          "facebookUrl": "",
          "twitterUrl": "",
          "instagramUrl": "",
          "linkedinUrl": "",
          "address1": address1,
          "address2": address2
        }
      }
    }
  };
};

var _default = getDefaultTemplate;
exports["default"] = _default;
module.exports = exports.default;